import React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import AppConfig from "./config/app.config";
import Page403 from "./pages/403";
import Page404 from "./pages/404";
import AssinaturaVerificacao from "./pages/Assinatura/AssinaturaVerificacao";
import CustomRoutes from "./pages/CustomRoutes";
import Layout from "./pages/Layout";
import Login from "./pages/Login";
import Wiki from "./pages/__Wiki__/Exemplos";

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route exact path="/docs/:ticket" component={AssinaturaVerificacao} />
        <CustomRoutes isPrivate path="/app" component={Layout} />

        {/* Nossa Wiki de Exemplos - Exibição disponível apenas em DEV */}
        {["dev", "hom"].indexOf(AppConfig.env) !== -1 && <Route path="/wiki" component={Wiki} />}

        <Route path="*" component={Page404} />
        <Route path="/app/403" component={Page403} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
